import api from './api'

const bugReportService = {
  /**
   * File a new bug report (creates a GitHub Issue via backend proxy).
   * Accepts FormData when a screenshot is attached.
   */
  create: async (data) => {
    // Force multipart/form-data so Axios sends FormData as binary (not JSON-serialized)
    const config =
      data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}
    const response = await api.post('/bug-reports', data, config)
    return response.data
  },

  /**
   * List filed bug reports (from GitHub Issues).
   * @param {Object} params - { status: 'all'|'open'|'closed', severity: string, page: number }
   */
  list: async (params = {}) => {
    const response = await api.get('/bug-reports', { params })
    return response.data
  },

  /**
   * Get bug report statistics.
   */
  getStats: async () => {
    const response = await api.get('/bug-reports/stats')
    return response.data
  },
}

export default bugReportService
